import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { WorkspaceActivity } from './components/workspaceActivity';
import { WorkspaceDetail } from './components/workspaceDetail';
import { WorkspaceDetailExpanded } from './components/workspaceDetailExpanded';
import { WorkspaceEdit } from './components/workspaceEdit';
import { WorkspaceNewIssue } from './components/workspaceNewIssue';
import { Workspaces } from './components/workspaces';
import { WorkspacesFilterPage } from './components/workspacesFilterPage';
import { WorkspacesToolbar } from './components/workspacesToolbar';

export const workspacePaths = {
  root: 'workspaces',
};

export const workspaceRoute = [
  {
    path: workspacePaths.root,
    element: <Workspaces />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.workspace.all,
      toolbar: <WorkspacesToolbar />,
    },
  },
  {
    path: `${workspacePaths.root}/filters`,
    element: <WorkspacesFilterPage />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.workspace.all,
    },
  },
  {
    path: `${workspacePaths.root}/:workspaceId`,
    element: <WorkspaceDetail />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  {
    path: `${workspacePaths.root}/:workspaceId/detail`,
    element: <WorkspaceDetailExpanded />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  {
    path: `${workspacePaths.root}/:workspaceId/edit`,
    element: <WorkspaceEdit />,
    handle: {
      header: {
        titleKey: 'workspace.editTitle',
        icon: 'group',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  {
    path: `${workspacePaths.root}/:workspaceId/activity/new`,
    element: <WorkspaceNewIssue />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  {
    path: `${workspacePaths.root}/:workspaceId/activity/:issueId`,
    element: <WorkspaceActivity />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
];
